import React from "react"

export default (props) => {
  const fillColor = ''
  return (
    <svg
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1015 608"
      {...props}
    >
      <defs>
        <ellipse id="a" cx={179.5} cy={170} rx={44.5} ry={45} />
      </defs>
      <use
        xlinkHref="#a"
        overflow="visible"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <clipPath id="b">
        <use xlinkHref="#a" overflow="visible" />
      </clipPath>
      <g clipPath="url(#b)">
        <defs>
          <path id="c" d="M-3118-337h4937v1348h-4937z" />
        </defs>
        <use xlinkHref="#c" overflow="visible"  />
        <clipPath id="d">
          <use xlinkHref="#c" overflow="visible" />
        </clipPath>
        <path clipPath="url(#d)"  d="M130 120h99v100h-99z" />
      </g>
      <defs>
        <ellipse id="e" cx={179.5} cy={45} rx={44.5} ry={45} />
      </defs>
      <use
        xlinkHref="#e"
        overflow="visible"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <clipPath id="f">
        <use xlinkHref="#e" overflow="visible" />
      </clipPath>
      <g clipPath="url(#f)">
        <defs>
          <path id="g" d="M-3118-337h4937v1348h-4937z" />
        </defs>
        <use xlinkHref="#g" overflow="visible"  />
        <clipPath id="h">
          <use xlinkHref="#g" overflow="visible" />
        </clipPath>
        <path clipPath="url(#h)"  d="M130-5h99V95h-99z" />
      </g>
      <defs>
        <path
          id="i"
          d="M224 292.5v271c0 24.6-19.9 44.5-44.5 44.5S135 588.1 135 563.5v-271c0-24.6 19.9-44.5 44.5-44.5s44.5 19.9 44.5 44.5z"
        />
      </defs>
      <use
        xlinkHref="#i"
        overflow="visible"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <clipPath id="j">
        <use xlinkHref="#i" overflow="visible" />
      </clipPath>
      <g clipPath="url(#j)">
        <defs>
          <path id="k" d="M-3118-337h4937v1348h-4937z" />
        </defs>
        <use xlinkHref="#k" overflow="visible"  />
        <clipPath id="l">
          <use xlinkHref="#k" overflow="visible" />
        </clipPath>
        <path clipPath="url(#l)"  d="M130 243h99v370h-99z" />
      </g>
      <defs>
        <ellipse id="m" cx={44.5} cy={446} rx={44.5} ry={45} />
      </defs>
      <use
        xlinkHref="#m"
        overflow="visible"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <clipPath id="n">
        <use xlinkHref="#m" overflow="visible" />
      </clipPath>
      <g clipPath="url(#n)">
        <defs>
          <path id="o" d="M-3118-337h4937v1348h-4937z" />
        </defs>
        <use xlinkHref="#o" overflow="visible"  />
        <clipPath id="p">
          <use xlinkHref="#o" overflow="visible" />
        </clipPath>
        <path clipPath="url(#p)"  d="M-5 396h99v100H-5z" />
      </g>
      <g>
        <defs>
          <path
            id="q"
            d="M89 52.5v271c0 24.6-19.9 44.5-44.5 44.5S0 348.1 0 323.5v-271C0 27.9 19.9 8 44.5 8S89 27.9 89 52.5z"
          />
        </defs>
        <use
          xlinkHref="#q"
          overflow="visible"
          fillRule="evenodd"
          clipRule="evenodd"
        />
        <clipPath id="r">
          <use xlinkHref="#q" overflow="visible" />
        </clipPath>
        <g clipPath="url(#r)">
          <defs>
            <path id="s" d="M-3118-337h4937v1348h-4937z" />
          </defs>
          <use xlinkHref="#s" overflow="visible"  />
          <clipPath id="t">
            <use xlinkHref="#s" overflow="visible" />
          </clipPath>
          <path clipPath="url(#t)"  d="M-5 3h99v370H-5z" />
        </g>
      </g>
      <g>
        <defs>
          <path
            id="u"
            d="M1015 567.4c-.3.5-.7 1.2-1.2 2s-1.2 1.2-2 1.2h-14.4l-105-100.9v97.7l-3.2 3.2h-10l-3.6-3.2V269.2l3.2-3.2h10l3.2 3.2v182.9c15.2-12.5 30.2-24.9 44.9-37.2 14.7-12.3 29.5-24.7 44.5-37.2h14c2.4 0 3.6 1.1 3.6 3.2l-1.2 2.4-95 76.4c18.7 17.6 37.3 35.1 55.9 52.4 18.6 17.3 36.9 35 55.1 52.8.8.9 1.2 1.7 1.2 2.5zM836.4 395.3l-4 2.8c-2.7-1.1-5.6-1.7-8.8-1.8-3.2-.1-6-.2-8.4-.2-7.2 0-14.1 1.3-20.6 4-6.5 2.7-12.3 6.3-17.2 10.8-4.9 4.5-8.9 9.9-11.8 16.2-2.9 6.3-4.4 13.1-4.4 20.6v119.7l-3.2 3.2h-10.4l-3.2-3.2V384.1l2.8-3.2h10.4l3.2 3.2v26c7.2-9.9 16-17.5 26.2-22.8 10.3-5.3 21.4-8 33.5-8h6.8c2.1 0 4.3.3 6.4.8l2.8 3.2v12zm-181.7 74.4c-5.6-.5-11.2-.8-16.8-.8h-16.4c-8.3 0-16.6.5-25 1.6-8.4 1.1-16 3.3-22.8 6.8-6.8 3.5-12.4 8.3-16.8 14.4s-6.6 14.1-6.6 24c0 5.6.9 11 2.8 16.2 1.9 5.2 4.5 9.7 8 13.6s7.6 7 12.4 9.4c4.8 2.4 10.2 3.6 16 3.6 9.6 0 18.2-1.9 25.8-5.6 7.6-3.7 14.1-8.8 19.4-15.2 5.3-6.4 9.6-13.7 12.8-21.8 3.2-8.1 5.2-16.6 6-25.4.3-3.5.5-6.9.6-10.4.1-3.5.2-6.9.2-10.4h.4zm16.8 97.7l-3.2 3.2h-8.8l-3.2-3.2-.8-36.8c-6.7 13.3-15.5 23.7-26.4 31.2-11 7.5-24 11.2-39.3 11.2-17.1 0-31-5.3-41.7-15.8-10.7-10.5-16-24.3-16-41.4 0-10.7 2-19.5 6-26.6 4-7.1 9.4-12.9 16-17.4 6.7-4.5 14.3-7.9 22.8-10.2 8.5-2.3 17.4-3.8 26.4-4.6 9.1-.8 18-1.2 26.8-1.2 9.1 0 17.4.1 24.8.4v-21.6c0-16-4.3-26.9-12.8-32.6-8.5-5.7-20.2-8.6-34.9-8.6-7.5 0-14.8 1.1-21.8 3.2-7.1 2.1-13.4 4.5-18.8 7-5.5 2.5-10 4.9-13.6 7-3.6 2.1-5.7 3.2-6.2 3.2-1.1 0-1.8-.7-2.2-2-.4-1.3-.7-2.9-.8-4.8-.1-1.9-.1-3.6 0-5.2s.2-2.8.2-3.6l1.2-2.8c4-2.7 8.6-5.1 13.8-7.2 5.2-2.1 10.6-3.9 16-5.2 5.5-1.3 11-2.3 16.4-3 5.5-.7 10.6-1 15.4-1 10.2 0 19.2.8 27.3 2.4 8 1.6 14.8 4.5 20.2 8.8 5.5 4.3 9.7 9.9 12.6 17 2.9 7.1 4.4 16.2 4.4 27.4v132.8zM459.7 398.5c-6.9-2.1-15.2-3.5-24.6-4.2s-17.8-1-25-1c-28.1 0-48.5 7.4-61.3 22.2-12.8 14.8-19.2 35.8-19.2 63 0 10.9 1.1 21.2 3.4 30.8 2.3 9.6 6 18.1 11.2 25.4 5.2 7.3 12 13.1 20.2 17.4 8.3 4.3 18.4 6.4 30.5 6.4 11.2 0 20.9-2.3 29.1-7s14.8-10.7 20-18.2c5.2-7.5 9.1-16 11.6-25.6 2.5-9.6 3.8-19.3 3.8-29.2l.3-80zm16.4 168.9l-2.8 3.2h-9.2l-3.2-3.2-.8-36.4c-6.4 12.8-15.4 23-26.8 30.6-11.5 7.6-24.4 11.4-38.9 11.4-14.7 0-27.2-2.3-37.5-7s-18.7-11.2-25.2-19.6-11.3-18.4-14.2-30c-2.9-11.6-4.4-24.2-4.4-37.8 0-33.4 7.7-58.3 23.2-74.8S376.4 379 410 379c8.3 0 16.6.3 24.8.8 8.3.5 16.6 1.2 24.8 2V269.6l3.2-3.2h10.4l2.8 3.2v297.8z"
          />
        </defs>
        <use
          xlinkHref="#u"
          overflow="visible"
          fillRule="evenodd"
          clipRule="evenodd"
        />
        <clipPath id="v">
          <use xlinkHref="#u" overflow="visible" />
        </clipPath>
        <g clipPath="url(#v)">
          <defs>
            <path id="w" d="M-3118-337h4937v1348h-4937z" />
          </defs>
          <use xlinkHref="#w" overflow="visible"  />
          <clipPath id="x">
            <use xlinkHref="#w" overflow="visible" />
          </clipPath>
          <path clipPath="url(#x)"  d="M308 261h712v317H308z" />
        </g>
      </g>
      <g>
        <defs>
          <path
            id="y"
            d="M75 573.6L14 605v-11.8l53.8-27.1L14 538.8V528l61 31.5z"
          />
        </defs>
        <use
          xlinkHref="#y"
          overflow="visible"
          fillRule="evenodd"
          clipRule="evenodd"
        />
        <clipPath id="z">
          <use xlinkHref="#y" overflow="visible" />
        </clipPath>
        <g clipPath="url(#z)">
          <defs>
            <path id="A" d="M-3118-337h4937v1348h-4937z" />
          </defs>
          <use xlinkHref="#A" overflow="visible"  />
          <clipPath id="B">
            <use xlinkHref="#A" overflow="visible" />
          </clipPath>
          <path clipPath="url(#B)"  d="M9 523h71v87H9z" />
        </g>
      </g>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/components/Logo.js